/*
 * fn: buildRouteParam
 *
 * Writes a single route param value back out to its raw URL string
 *
 */
import {
  getRouteParamConfig,
  type RouteParamsConfigType,
  type RouteParamsType,
  type RouteParamValueType,
} from '@/defs/route'

import { buildAdvancedRoute } from './buildAdvancedRoute'

type ParserType = NonNullable<RouteParamsConfigType['parser']>

const BUILDERS = {
  advancedFilters: (value: RouteParamValueType) => (Array.isArray(value) ? buildAdvancedRoute(value) : undefined),
  pageNumber: (value: RouteParamValueType) => (typeof value === 'number' && value > 1 ? String(value) : undefined),
} satisfies Record<ParserType, (value: RouteParamValueType) => string | undefined>

export const buildRouteParam = (param: keyof RouteParamsType, value: RouteParamValueType) => {
  const { parser } = getRouteParamConfig(param)

  if (parser) return BUILDERS[parser](value)

  return typeof value === 'string' && value ? value : undefined
}
